// extracted by mini-css-extract-plugin
module.exports = {"productType_container":"ProductType_productType_container__PgWHq","productTypeBoxList_container":"ProductType_productTypeBoxList_container__3Yxeg"};